<div class="row homepage">
  <div class="col-12 haveVideo">
    <video autoplay muted loop playsinline class="haveVideo--video">
      <source src="./../../assets/images/herovideo.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="headContent">
      <div class="container-xl">
        <div class="row">
          <div class="offset-lg-6 col-md-12 col-12 col-lg-6">
            <div class="headContent-col">
              <div
                class="col f-p headContent--head"
                data-aos="fade-left"
                data-aos-duration="1000">
                {{ herosConfig.title }}
              </div>
              <div class="col f-m headContent--content" data-aos="fade-left">
                {{ herosConfig.description }}
              </div>
              <div class="col headContent--btn" data-aos="fade-down">
                <button class="primaryBtn" routerLink="/pricing">
                  Get Started risk-free!
                </button>
                <button class="primaryBtn" routerLink="/book-demo">
                  Talk to an Expert
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Overlay">
      <div class="container-xl overflow-hidden">
        <div class="row clients align-items-center justify-content-between">
          <div class="col-auto">
            <img src="assets/images/client-logo/jpmorgan.png" alt="JP Morgan" />
          </div>
          <div class="col-auto">
            <img src="assets/images/client-logo/wallmart.png" alt="wallmart" />
          </div>
          <div class="col-auto">
            <img src="assets/images/client-logo/samsung.png" alt="samsung" />
          </div>
          <div class="col-auto">
            <img src="assets/images/client-logo/amazon.png" alt="amazon" />
          </div>
          <div class="col-auto">
            <img src="assets/images/client-logo/lenovo.png" alt="Lenovo" />
          </div>
          <div class="col-auto">
            <img
              src="assets/images/client-logo/microsoft.png"
              alt="Microsoft" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 feature-section dark-theme">
    <div class="container-xl">
      <h4 class="f-m sfont32 mt-2">
        Revolutionize Your Contact Center Operations with iKunnect
      </h4>
      <h5 class="sfont24 f-m">
        Is your contact center slowing you down instead of driving growth?
        iKunnect's intelligent automation, AI-driven insights, and seamless
        omnichannel integration help you delivering faster resolutions, better
        customer experience, and higher agent efficiency.
      </h5>
      <div class="custom-tabs tabs-4">
        <!-- Tab panes -->
        <div class="tab-content py-4">
          <div id="tab1" class="container tab-pane active">
            <div class="row align-items-center">
              <div class="col-12 col-md-6">
                <div class="home-tabs-cont">
                  <h6 class="f-p">Inbound Contact Center</h6>
                  <p class="f-a">
                    iKunnect automatically routes calls to the right agent
                    instantly, reducing wait times and improving first call
                    resolution.
                  </p>
                  <div class="d-flex">
                    <button class="secondaryBtn" routerLink="/solutions">
                      EXPLORE SOLUTION
                    </button>
                    <button
                      class="secondaryBtn text see-all-btn"
                      routerLink="/platform">
                      SEE ALL FEATURES
                      <i class="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-6 text-right">
                <div class="transformCustomer--right">
                  <div class="image-container">
                    <div class="image1">
                      <img src="assets/images/inbound1.png" alt="" />
                    </div>
                    <div class="image2">
                      <img src="assets/images/inbound2.png" alt="" />
                    </div>
                    <div class="image3">
                      <img src="assets/images/inbound3.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="tab2" class="container tab-pane fade">
            <div class="row align-items-center">
              <div class="col-12 col-md-6">
                <div class="home-tabs-cont">
                  <h6 class="f-p">Outbound Contact Center</h6>
                  <p>
                    Drive outreach success with powerful outbound call
                    automation.
                  </p>
                  <div class="d-flex">
                    <button class="secondaryBtn" routerLink="/solutions">
                      EXPLORE SOLUTION
                    </button>
                    <button
                      class="secondaryBtn text see-all-btn"
                      routerLink="/platform">
                      SEE ALL FEATURES
                      <i class="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-6 text-right">
                <div class="transformCustomer--right">
                  <div class="image-container">
                    <div class="image1">
                      <img src="assets/images/outbound1.png" alt="" />
                    </div>
                    <div class="image2">
                      <img src="assets/images/outbound2.png" alt="" />
                    </div>
                    <div class="image3">
                      <img src="assets/images/outbound3.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="tab3" class="container tab-pane fade">
            <div class="row align-items-center">
              <div class="col-12 col-md-6">
                <div class="home-tabs-cont">
                  <h6 class="f-p">Back Office Optimization</h6>
                  <p>
                    Streamline workflows for efficient back-office operations.
                  </p>
                  <div class="d-flex">
                    <button class="secondaryBtn" routerLink="/solutions">
                      EXPLORE SOLUTION
                    </button>
                    <button
                      class="secondaryBtn text see-all-btn"
                      routerLink="/platform">
                      SEE ALL FEATURES
                      <i class="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-6 text-right">
                <div class="transformCustomer--right">
                  <div class="image-container">
                    <div class="image1">
                      <img src="assets/images/backoffice1.png" alt="" />
                    </div>
                    <div class="image2">
                      <img src="assets/images/backoffice2.png" alt="" />
                    </div>
                    <div class="image3">
                      <img src="assets/images/backoffice3.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="tab4" class="container tab-pane fade">
            <div class="row align-items-center">
              <div class="col-12 col-md-6">
                <div class="home-tabs-cont">
                  <h6 class="f-p">Managing Performance</h6>
                  <p>
                    Track and improve performance with actionable insights and
                    analytics.
                  </p>
                  <div class="d-flex">
                    <button class="secondaryBtn" routerLink="/solutions">
                      EXPLORE SOLUTION
                    </button>
                    <button
                      class="secondaryBtn text see-all-btn"
                      routerLink="/platform">
                      SEE ALL FEATURES
                      <i class="bi bi-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-6 text-right">
                <div class="transformCustomer--right">
                  <div class="image-container">
                    <div class="image1">
                      <img src="assets/images/performace1.png" alt="" />
                    </div>
                    <div class="image2">
                      <img src="assets/images/performance2.png" alt="" />
                    </div>
                    <div class="image3">
                      <img src="assets/images/performance3.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#tab1">
              Inbound Contact Center
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#tab2">
              Outbound Contact Center
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#tab3">
              Back Office Optimization
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#tab4">
              Managing Performance
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-12 trail-cta">
    <div class="container-xl">
      <h1 class="sfont48 mb-2" data-aos="fade-down">Get started risk free!</h1>
      <div class="row">
        <div class="col-12 col-md-8">
          <p class="sfont18 f-a mb-5">
            Access iKunnect features for 30 days, then decide which plan best
            suites your needs.
          </p>
          <span class="sfont15 f600">Business email address</span>
          <div class="row haveForm">
            <div class="col-12 col-md-7 col-lg-8">
              <input type="text" class="plainField" />
            </div>
            <div class="col-12 col-md-5 col-lg-4">
              <button
                class="primaryBtn sfont13 lessRadius"
                routerLink="/pricing">
                START YOUR FREE TRIAL
              </button>
            </div>
          </div>
          <!-- <p class="smt4">
            Or
            <strong
              ><u class="cursor-p"
                >compare plans from $125/mo per user</u
              ></strong
            >
          </p> -->
        </div>
        <div class="col-12 col-md-4 trail-cta--list">
          <ul>
            <li data-aos="fade-up" data-aos-duration="500">
              <i class="bi bi-check2-circle"></i>
              Safe and secure
            </li>
            <li data-aos="fade-up" data-aos-duration="1000">
              <i class="bi bi-check2-circle"></i>
              Cancel any time
            </li>
            <li data-aos="fade-up" data-aos-duration="1500">
              <i class="bi bi-check2-circle"></i>
              24/7 online support
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="container-xl text-center">
      <div class="meetYourOucomes">
        <h5 class="sfont24 f500">
          Reliable and efficient contact center solution
        </h5>
        <h1
          class="sfont48 f500 smb6 f-p"
          data-aos="fade-down"
          data-aos-duration="1000">
          Tailored to Meet Your Business Goals
        </h1>
        <div class="row lightBlue">
          <div
            class="col-xs-12 col-sm-5 lightBlue__text"
            data-aos="fade-up"
            data-aos-duration="1000">
            <h4 class="mb-3 f-p">
              Small to Medium-Sized <br />
              Enterprises (SMEs)
            </h4>
            <p class="sfont18 f400 f-a">
              Strugglig with scaling support without losing quality? iKunnect
              automates workflows, enhances customer insights, and optimizes
              agent performance.
            </p>
            <button class="flatBtn c-p f600" (click)="bookConsult()">
              BOOK A CALL <i class="bi bi-arrow-right"></i>
            </button>
          </div>
          <div
            class="col-xs-12 col-sm-7 lightBlue__right"
            data-aos="fade-left"
            data-aos-duration="1000">
            <img src="assets/images/tailored1.png" alt="" class="md-full" />
            <img src="assets/images/objects-4.png" alt="" class="floating" />
          </div>
        </div>
        <div class="row colouts gap-0">
          <div
            class="col-xs-12 col-sm-12 col-md-6"
            data-aos="fade-right"
            data-aos-duration="1000">
            <div class="colouts__each">
              <h2>Large Contact Centers</h2>
              <p>
                Handling high contact volumes doesn't have to be overwhelming.
                iKunnect transforms chaotic operations into seamless,
                hgih-efficiency workflows by intelligently managing every aspect
                of your contact center.
              </p>
              <button class="flatBtn c-p f600" (click)="bookConsult()">
                TALK WITH US <i class="bi bi-arrow-right"></i>
              </button>
              <img src="assets/images/large1.png" alt="" />
            </div>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-6"
            data-aos="fade-left"
            data-aos-duration="1000">
            <div class="colouts__each">
              <h2 class="" title="Remote & Hybrid Teams">
                Remote & Hybrid Teams
              </h2>
              <!--ellipsis-singleline-->
              <p>
                iKunnect empowers your remote workforce with intelligent
                collaboration tools, ensuring seamless communication across time
                zones.
              </p>
              <button class="primaryBtn" (click)="bookConsult()">
                 GET STARTED!
              </button>
              <p>&nbsp;</p>
              <img src="assets/images/remote1.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 invictus-services">
    <div class="container-xl text-center">
      <img
        src="assets/images/invictus-logo-big.png"
        class="mb-2"
        alt=""
        data-aos="fade-down" />
      <h1 class="mb-4" data-aos="fade-up">
        More than just software, <br />
        we’re contact center practitioners
      </h1>
      <div
        class="accordion basic-accordion accordion-flush"
        id="accordionFlushExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne">
              Inbound Contact Center Services
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Transform your inbound call handling with tools that optimize
                response times and ensure seamless customer experiences. Our
                solution integrates intelligent routing, call tracking, and
                comprehensive reporting to streamline operations and boost
                satisfaction.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo">
              Outbound Contact Center Services
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Enhance outbound call efficiency with a platform designed for
                sales, lead generation, and customer outreach. Leverage
                predictive dialing, multi-channel integration, and actionable
                insights to drive meaningful connections and maximize impact.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseThree"
              aria-expanded="false"
              aria-controls="flush-collapseThree">
              Consolidated Service Desk
            </button>
          </h2>
          <div
            id="flush-collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Centralize your customer and IT support operations with our
                service desk solution. Simplify workflows, accelerate issue
                resolution, and provide consistent support across departments
                with integrated tools and real-time dashboards.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFour"
              aria-expanded="false"
              aria-controls="flush-collapseFour">
              Enterprise GBS Customer Services
            </button>
          </h2>
          <div
            id="flush-collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Empower your enterprise with scalable solutions for global
                customer service delivery. Handle high-volume inquiries, unify
                multi-channel interactions, and maintain operational excellence
                with features built for enterprise needs.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFive"
              aria-expanded="false"
              aria-controls="flush-collapseFive">
              Back Office Operations
            </button>
          </h2>
          <div
            id="flush-collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Streamline back-office processes with automation and workflow
                management tools. From administrative tasks to data processing,
                our solution minimizes errors and enhances operational
                efficiency, freeing your team for strategic priorities.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseSix"
              aria-expanded="false"
              aria-controls="flush-collapseSix">
              Hybrid Services & Disaster Recovery
            </button>
          </h2>
          <div
            id="flush-collapseSix"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
              <p>
                Ensure business continuity with hybrid support solutions that
                adapt to your needs. Our disaster recovery capabilities provide
                seamless fallback and operational stability to protect your
                business from unexpected disruptions.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!--
      <button (click)="isChatEnabled = true" class="primaryBtn mt-5">
        LET'S CHAT
      </button>
    -->
    </div>
  </div>
  <!-- <div class="col-12">
    <div class="container-xl">
      <app-about />
    </div>
  </div> -->
  <div class="col-12">
    <div class="container-xl">
      <div class="integrations">
        <div class="row">
          <div
            class="col-12 col-lg-6"
            data-aos="fade-right"
            data-aos-duration="1000">
            <div class="row">
              <div class="col-12 sfont48 f500 f-p l-h-58">
                Seamlessly Integrate and Optimize Your Tools
              </div>
              <div class="col-12 sfont24 f500 l-h-30 my-3 f-m">
                Discover integration capabilities that connect your systems for
                smarter workflows. Let us help you turn your vision into
                reality.
              </div>
              <div class="col-12">
                <button class="primaryBtn" (click)="bookConsult()">
                  GET A PERSONALIZED DEMO
                </button>
              </div>
              <div class="mui-spacer"></div>

              <div class="col-12">
                <img
                  src="assets/images/security-badges.png"
                  alt=""
                  class="md-full" />
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000">
            <div class="accordion customAccrodion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne">
                    <img src="./../../assets/images/crm-icon.png" alt="" />
                    Real-Time Analytics
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      iKunnect's Real-Time Analytics platform gives you
                      instantly visibility into your contact center's
                      performace, allowing you to make data-driven decisios on
                      the fly. Monitor agent efficiency, call volumes, customer
                      sentiment, and resolution rates in real time through an
                      intuitive, AI-powered dashboard. With customizable
                      reports, predictive insights, and automated alerts,
                      iKunnect helps you identify trends, optimize staffing, and
                      enhace customer interactions before issues arise. Stay
                      ahead of the curve with live data that empowers smarter,
                      faster, and more efficient contact center management.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo">
                    <img
                      src="./../../assets/images/back-office-icon.png"
                      alt="" />
                    Back office integration
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      Unify your back-office operations with iKunnect's
                      integration capabilities. From data synchronization to
                      automated updates, our platform ensures a smooth flow of
                      information between your contact center and administrative
                      systems. Eliminate silos, improve accuracy, and boost
                      operational efficiency, giving your team more time to
                      focus on strategic tasks.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree">
                    <img src="./../../assets/images/eod-icon.png" alt="" />
                    End-of-day processing
                    <!-- <img src="../../assets/images/plus.png" class="plus" />
                  <img src="../../assets/images/plus.png" class="plus" /> -->
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <p>
                      iKunnect simplifies end-of-day processes by automating key
                      workflows and consolidating reports. Whether it's
                      reconciling call data, updating customer records, or
                      generating daily performance insights, our solution saves
                      time and reduces manual errors. Gain actionable insights
                      to optimize your operations while ensuring your systems
                      are always up-to-date.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-explore-resources class="spa0 col-12"></app-explore-resources>
  <app-book-consultation [title]="title" class="spa0 col-12" />
  <app-lets-chat *ngIf="isChatEnabled"></app-lets-chat>
</div>
